import React from 'react';
import { Card } from 'react-bootstrap';
import MultiLevelAccordion from '../../atp_modules/MultiLevelAccordion';
import { Container, Row, Col, Button, Accordion } from 'react-bootstrap';

const jsonData = [
    {
        "header": "Tense",
        "text": "Description for Level 1 Item 1",
        "items": [
            {
                "header": "Present Tense",
                "text": "Learn about Present Tense",
                "items": [
                    { "header": "Simple Present Tense", "text": "Learn about Simple Present Tense", "body": "" },
                    { "header": "Present Continuous Tense", "text": "Learn about Present Continuous Tense", "body": "" },
                    { "header": "Present Perfect Tense", "text": "Learn about Present Perfect Tense", "body": "" },
                    { "header": "Present Perfect Continuous Tense", "text": "Learn about Present Perfect Continuous Tense", "body": "" }
                ]
            },
            {
                "header": "Past Tense",
                "text": "Learn about Past Tense",
                "items": [
                    { "header": "Simple Past Tense", "text": "Learn about Simple Past Tense", "body": "" },
                    { "header": "Past Continuous Tense", "text": "Learn about Past Continuous Tense", "body": "" },
                    { "header": "Past Perfect Tense", "text": "Learn about Past Perfect Tense", "body": "" },
                    { "header": "Past Perfect Continuous Tense", "text": "Learn about Past Perfect Continuous Tense", "body": "" }

                ]
            },
            {
                "header": "Future Tense",
                "text": "Learn about Future Tense",
                "items": [
                    { "header": "Simple Future Tense", "text": "Learn about Simple Future Tense", "body": "" },
                    { "header": "Future Continuous Tense", "text": "Learn about Future Continuous Tense", "body": "" },
                    { "header": "Future Perfect Tense", "text": "Learn about Future Perfect Tense", "body": "" },
                    { "header": "Future Perfect Continuous Tense", "text": "Learn about Future Perfect Continuous Tense", "body": "" }

                ]
            }
        ]
    },
    {
        "header": "Prepositions",
        "text": "Learn about Prepositions",
        "items": [
            { "header": "Simple Prepositions", "text": "Learn about Simple Prepositions", "body": "" },
            { "header": "Common Compound Prepositions", "promptTopic": "Common Compound Prepositions (prepositions made up of more than one word)", "text": "Learn about Common Compound Prepositions which are prepositions that consist of more than one word", "body": "" },
            { "header": "Common Phrasal Prepositions", "promptTopic": "Common Phrasal Prepositions (combinations of words that function together as a unit)", "text": "Learn about Common Phrasal Prepositions which are groups of words that function as prepositions", "body": "" }
        ]
    },
    {
        "header": "Voice in English Grammar",
        "text": "Learn about Voice in English Grammar",
        "items": [
            { "header": "Active Voice", "text": "Learn about Active Voice", "body": "" },
            { "header": "Passive Voice", "text": "Learn about Passive Voice", "body": "" },
            { "header": "Change an Active Voice sentence into a Passive Voice sentence", "text": "Learn how to change Active Voice sentences into Passive Voice sentences", "body": "", "questiontypes": "rewritesentence" },
            { "header": "Change a Passive Voice sentence into an Active Voice sentence", "text": "Learn how to change Passive Voice sentences into Active Voice sentences", "body": "", "questiontypes": "rewritesentence" },
            { "header": "Identify the Verb - Active Voice or Passive Voice", "text": "Learn how to identify whether a Verb is in the Active Voice or in the Passive Voice", "body": "", "questiontypes": "multiplechoice" }
        ]
    },
    {
        "header": "Personal Pronouns", "promptTopic": "Personal Pronouns (Pronoun is a word used instead of a Noun)",
        "text": "Learn about Personal Pronouns",
        "items": [
            { "header": "First Person Personal Pronouns", "promptTopic": "First Person Personal Pronouns (Masculine,Feminine, Singular,Plural)", "text": "Learn about First Person Personal Pronouns", "body": "" },
            { "header": "Second Person Personal Pronouns", "promptTopic": "Second Person Personal Pronouns (Masculine,Feminine, Singular,Plural)", "text": "Learn about Second Person Personal Pronouns", "body": "" },
            { "header": "Third Person Personal Pronouns", "promptTopic": "Third Person Personal Pronouns (Masculine,Feminine, Singular,Plural)", "text": "Learn about First Person Personal Pronouns", "body": "" },
            { "header": "Demonstrative Pronouns", "promptTopic": "Demonstrative Pronouns (Pronouns pointing out the objects to which they refer)", "text": "Learn about Demonstrative Pronouns", "body": "" },
            { "header": "Indefinite Pronouns", "promptTopic": "Indefinite Pronouns (Pronouns referring to persons or things in a general way)", "text": "Learn about Indefinite Pronouns", "body": "" },
            { "header": "Distributive Pronouns", "promptTopic": "Distributive Pronouns (Pronouns referring to persons or things one at a time)", "text": "Learn about Distributive Pronouns", "body": "" },
            { "header": "Relative Pronouns", "promptTopic": "Relative Pronouns (Pronouns that refer to or relate to nouns going before)", "text": "Learn about Relative Pronouns", "body": "" },
            { "header": "Interrogative Pronouns", "promptTopic": "Interrogative Pronouns (Pronouns that are used for asking questions)", "text": "Learn about Interrogative Pronouns", "body": "" }
        ]
    },
    {
        "header": "The Verb: Person and Number",
        "promptTopic": "The Verb: Person and Number (The Verb must agree with its Subject in Number and Person)",
        "text": "Learn about The Verb: Person and Number",
        "items": [
            { "header": "First Person Singular Verb", "text": "Learn about First Person Singular Verbs", "body": "" },
            { "header": "First Person Plural Verb", "text": "Learn about First Person Plural Verbs", "body": ""  },
            { "header": "Second Person Singular Verb", "text": "Learn about Second Person Singular Verbs", "body": "" },
            { "header": "Second Person Plural Verb", "text": "Learn about Second Person Plural Verbs", "body": ""  },
            { "header": "Third Person Singular Verb", "text": "Learn about Third Person Singular Verbs", "body": "" },
            { "header": "Third Person Plural Verb", "text": "Learn about Third Person Plural Verbs", "body": ""  }
        ]
    }
];

const jsonDataCommonMistakes = [
    {
        "header": "Subject-Verb Agreement Mistakes",
        "promptTopic": "Subject-Verb Agreement Mistakes (Verb in a sentence does not match the subject either in number or person)",
        "text": "Description for Level 1 Item 1"
    },
    {
        "header": "Positive, comparative, and superlative degrees",
        "promptTopic": "Common mistakes when using positive, comparative, and superlative degrees",
        "text": "Learn about common mistakes when using positive, comparative, and superlative degrees"
    }
];

const ExploreGrammar = () => {
    return (
    <Container>
        <Container className="my-2">
        <Card className="mb-4">
            <Card.Body>
                <div className="bg-primary text-white pt-3 px-3 pb-1 mb-3 rounded">
                    <h5>Explore English Grammar</h5>
                    <p>Learn and practice various aspects of English Grammar with our interactive content.</p>
                </div>
                <MultiLevelAccordion data={jsonData} />
            </Card.Body>
        </Card>
        <Card className="mb-4">
            <Card.Body>
                <div className="bg-primary text-white pt-3 px-3 pb-1 mb-3 rounded">
                    <h5>English Grammar Common Mistakes</h5>
                    <p>Learn about common mistakes. Practice with our interactive content.</p>
                </div>
                <MultiLevelAccordion data={jsonDataCommonMistakes} />
            </Card.Body>
        </Card>
        </Container>
    </Container>
    );
};

export default ExploreGrammar;
